
export enum PageChangeActionType {
    StartLoadingPage = 'StartLoadingPage',
    PageLoadedSuccessfully = 'PageLoadedSuccessfully',
    PageError = 'PageError',
    NotFoundPage = 'NotFoundPage',
    OtherActionType = '__OTHER__'
}

export type PageNotFoundAction = {
    type: PageChangeActionType.NotFoundPage
}

export type StartLoadingPageAction = {
    type: PageChangeActionType.StartLoadingPage,
    name: string,
}

export type PageLoadedSuccessfullyAction = {
    type: PageChangeActionType.PageLoadedSuccessfully,
    name: string
}

export type PageLoadError = {
    type: PageChangeActionType.PageError,
    name: string
}

export type PageChangeAction =
    PageNotFoundAction
    | StartLoadingPageAction
    | PageLoadedSuccessfullyAction
    | PageLoadError


export function startLoadingPage(name: string) : StartLoadingPageAction {
    return {
        type: PageChangeActionType.StartLoadingPage,
        name: name
    };
}

export function pageNotFound() : PageChangeAction {
    return {type: PageChangeActionType.NotFoundPage}
}

export function pageLoaded(name: string) : PageLoadedSuccessfullyAction {
    return {
        type: PageChangeActionType.PageLoadedSuccessfully,
        name: name
    }
}

export function pageLoadFailed(name: string) : PageLoadError {
    return {
        type: PageChangeActionType.PageError,
        name: name
    }
}